import { render, staticRenderFns } from "./netWorkModel.vue?vue&type=template&id=5bfb8759&scoped=true&"
import script from "./netWorkModel.vue?vue&type=script&lang=js&"
export * from "./netWorkModel.vue?vue&type=script&lang=js&"
import style0 from "./netWorkModel.vue?vue&type=style&index=0&id=5bfb8759&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb8759",
  null
  
)

export default component.exports